/**
 * @generated SignedSource<<b746e9fdd3fabe08f142a7ce288063a9>>
 * @relayHash aac7213d2b277a963b74ea3348e418cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f11ab13ef9b27d64ab8116ae5ee95523773b35e7857255faa8484bbc509d8863

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { pageLayout_projectsDirectoryLayout_RootQuery } from './pageLayout_projectsDirectoryLayout_RootQuery.graphql';

import isAllowingEndUsersToAccessCustomTemplates_provider from '@atlassian/jira-relay-provider/src/jira-custom-template-allow-end-users-to-create-custom-templates.relayprovider';

const node: PreloadableConcreteRequest<pageLayout_projectsDirectoryLayout_RootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f11ab13ef9b27d64ab8116ae5ee95523773b35e7857255faa8484bbc509d8863",
    "metadata": {},
    "name": "pageLayout_projectsDirectoryLayout_RootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider
    }
  }
};

export default node;
